const INVENTORY_TOOLTIPS = {
  inventory_sku     : 'Produk dapat memiliki banyak ukuran. Setiap item fisik dengan ukuran unik memiliki sku inventaris unik, yang dapat disimpan di lokasi yang berbeda.',
  id                : 'Pengidentifikasi unik di database',
  sellable_quantity : 'Jumlah item fisik produk ini yang dapat dijual',
  stored_quantity   : 'Jumlah item fisik produk ini yang disimpan di gudang',
  is_preorderable   : 'Apakah barang akan dikirim di luar SLA Tinkerlust?',
  preorder_days     : 'Jumlah hari sebelum produk dikirim',
  preorder_date     : 'Tanggal yang produk ini bisa dikirm kepada Customer',
  is_qty_managed    : 'Adalah jumlah yang disimpan yang dikelola oleh tinkerlust'
}

export default INVENTORY_TOOLTIPS